import { getRouteApi } from '@tanstack/react-router';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import type { LoanType } from '../../../types';
import { FormDropdown } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormDropdown';
import { useApplicantAttributionOptions } from '~/features/leadDetails/components/Overview/CustomerData/shared/useDropdownOptions';
import useLead from '~/features/leadDetails/hooks/useLead';

type Props = {
    name: `${LoanType}.${number}`;
    disabled: boolean;
};

export const CreditApplicantField: React.FC<Props> = ({ disabled, name }) => {
    const { t } = useTranslation();
    const { leadId } = getRouteApi('/_app/leads_/details/$leadId').useParams();
    const { data: lead } = useLead(leadId);
    const { control } = useFormContext<SchemaCreditRequestForm>();
    const options = useApplicantAttributionOptions();

    if (!lead?.antragsteller2) return null;

    return (
        <FormDropdown
            control={control}
            id={`${name}.gehoertZuAntragsteller`}
            label={t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.APPLICANT')}
            options={options}
            searchable={false}
            disabled={disabled}
        />
    );
};
